import { useAuth0 } from '@auth0/auth0-react';
import { AntdLayout, Button, Card, notification, Typography } from '@pankod/refine-antd';
import { IResourceComponentsProps } from '@pankod/refine-core';
import eloBooksDark from 'assets/images/elo-store.svg';
import { DashboardCards, DemoAppModal } from 'components/dashboard';
import { useUserData } from 'hooks';
import { useState } from 'react';
import { createDemo } from 'services/app-instance';
import MetaData from 'utilities/metadata';

const { Text } = Typography;

export const DashboardPage: React.FC<IResourceComponentsProps> = () => {
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
  const { user } = useUserData();
  const { loginWithRedirect } = useAuth0();

  const closeDemoModal = () => {
    setIsDemoModalOpen(false);
  };

  const handleCreateDemo = async (categoryId?: string) => {
    if (!user?.default_organization?.id) {
      notification.error({
        message: 'Failed',
        description: 'No default organization found for this user.',
      });
      return;
    }

    try {
      const demo = await createDemo(user.default_organization.id, categoryId);
      notification.info({
        message: 'Success',
        description:
          demo.message ||
          'A demo organization and application has been created for you. Redirected you to the app',
      });
      loginWithRedirect({
        orgId: demo.organizationId,
        platformId: demo.instansId,
      });
    } catch (err: any) {
      notification.error({
        message: 'Failed',
        description: err?.message || 'Failed to start demo.',
      });
    }
  };

  const CardTitle = (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '60px',
      }}
    >
      <img src={eloBooksDark} alt="Logo" style={{ height: '4rem', width: 'auto' }} />
    </div>
  );

  if (user && !user.platform) {
    return (
      <>
        <MetaData />
        <AntdLayout
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '80vh',
          }}
        >
          <Card
            style={{
              maxWidth: '400px',
              margin: 'auto',
            }}
            title={CardTitle}
          >
            <Button
              type="primary"
              size="large"
              block
              onClick={() => setIsDemoModalOpen(true)}
            >
              Try Demo
            </Button>
          </Card>
          <DemoAppModal
            isModalOpen={isDemoModalOpen}
            onClose={closeDemoModal}
            onSelectCategory={handleCreateDemo}
          />
        </AntdLayout>
      </>
    );
  }

  // if (user && user.organizations.length && (!user.organizationId || !user.defaultOrganization.id)) {
  //   return (
  //     <Row>
  //       {user.organizations.map((org: { id: string; name: string }) => (
  //         <Col key={org.id}>
  //           <Organization id={org.id} name={org.name} />
  //         </Col>
  //       ))}
  //     </Row>
  //   );
  // }

  if (user && user?.organization?.id && user?.platform?.id) {
    return (
      <>
        <MetaData />
        <DashboardCards name={''} amount={0} />
      </>
    );
  }

  return (
    <>
      <MetaData />
      <AntdLayout
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '80vh',
        }}
      >
        <Text
          style={{
            fontSize: '2rem',
            fontWeight: 600,
            color: '#B3BDCC',
          }}
        >
          Nothing to show!
        </Text>
      </AntdLayout>
    </>
  );
};
